import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import DatePicker from 'react-datepicker';
import moment from 'moment';

function ReportsDateModalForm({ close, createReport }) {
  const [asOfDate, setAsOfDate] = useState(moment().format('YYYY-MM-DD'));

  const handleCreate = () => createReport({ date: asOfDate });

  return (
    <>
      <div>
        <Row className="mt-0 mb-2 align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>As-of Date:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <DatePicker
              className="bo-input bo-date-picker bo-w-250"
              onChange={e => setAsOfDate(moment(e).format('YYYY-MM-DD'))}
              selected={new Date(asOfDate)}
              dateFormat="yyyy-MM-dd"
              customInput={<Form.Control />}
            />
          </Col>
        </Row>
      </div>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsDateModalForm;
